import React from "react";
import { BellRing } from "lucide-react";

const fecha = (s) => (s ? new Date(s).toLocaleString("es-CO", { dateStyle: "medium", timeStyle: "short" }) : "");

export const AvisoFirmas = ({ avisos, onAbrir }) => (
  <div className="rounded-xl border border-emerald-200 bg-emerald-50/70 p-4" data-testid="aviso-firmas-panel">
    <div className="flex items-center gap-3">
      <img src="/roge-cat.png" alt="Gato institucional Roge" className="h-14 w-auto shrink-0 drop-shadow-sm" />
      <div>
        <p className="flex items-center gap-2 text-sm font-semibold text-emerald-800"><BellRing className="h-4 w-4" /> {avisos.length === 1 ? "Un empleado terminó de firmar" : `${avisos.length} empleados terminaron de firmar`} todos sus documentos</p>
        <p className="text-xs text-emerald-700/80">Revisa la contratación para continuar con Gerencia y las afiliaciones.</p>
      </div>
    </div>
    <div className="mt-3 divide-y divide-emerald-100 rounded-lg border border-emerald-100 bg-white">
      {avisos.map((r) => (
        <div key={r.id} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2" data-testid={`aviso-firmas-item-${r.id}`}>
          <div className="min-w-0">
            <p className="text-sm font-medium text-slate-800">{r.nombre}</p>
            <p className="text-xs text-slate-400">{r.numero_contrato} · firmó el {fecha(r.firmas_completas_at)}{r.estado === "pendiente_gerencia" ? " · pendiente de Gerencia" : ""}</p>
          </div>
          <button onClick={() => onAbrir(r)} data-testid={`aviso-firmas-abrir-${r.id}`} className="rounded-lg bg-vino-700 px-3 py-1.5 text-xs font-semibold text-white hover:bg-vino-800">Revisar</button>
        </div>
      ))}
    </div>
  </div>
);
